import style from '../style/acumulator.module.css'
import Juntar from '../components/Juntar'

export default function Acumulator(){
    return(
        <main className={style.acumulator}>
            <Juntar />
        </main>
    )
}
